import { Assistant } from "../gateway/Assistant/Assistant";

const BALANCE_SHEET_BUCKET = `${publicSettings.aws.buckets.balancesheet}`;

export class SaveBalanceSheetBackupUsecase {
    constructor() {
        this.AssistantGateway = new Assistant();
    }

    async execute({
        accountingId = "",
        companyId = "",
        source = "",
        fileBase64 = "",
        contentType = "",
        date,
        originalName = ""
    } = {}) {
        const payload = this.sanitizeInput({
            accountingId,
            companyId,
            source,
            fileBase64,
            contentType,
            date,
            originalName
        });
        if (!payload.accountingId) return null;
        if (!payload.companyId) return null;
        if (!payload.source) return null;
        if (!payload.fileBase64) return null;
        if (!payload.date) return null;
        return await this.AssistantGateway.putObjectInBucket({
            bucket: BALANCE_SHEET_BUCKET,
            key: `${payload.accountingId}-${payload.companyId}-${payload.source}-${payload.date.year}-${payload.date.month}`,
            fileBase64: payload.fileBase64,
            contentType: payload.contentType,
            metadata: payload.metadata
        });
    }

    sanitizeInput({
        accountingId = "",
        companyId = "",
        source = "",
        fileBase64 = "",
        contentType = "",
        date,
        originalName = ""
    } = {}) {
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedCompanyId = String(companyId).trim();
        const sanitizedSource = String(source).trim();
        const sanitizedFileBase64 = String(fileBase64).trim();
        const sanitizedContentType = String(contentType).trim();
        const sanitizedOriginalName = String(originalName).trim();
        const sanitizedDate = this.sanitizeDate(date);
        if (!sanitizedDate) {
            return {
                accountingId: sanitizedAccountingId,
                companyId: sanitizedCompanyId,
                source: sanitizedSource,
                fileBase64: sanitizedFileBase64,
                contentType: sanitizedContentType,
                date: null,
                metadata: null
            };
        }
        return {
            accountingId: sanitizedAccountingId,
            companyId: sanitizedCompanyId,
            source: sanitizedSource,
            fileBase64: sanitizedFileBase64,
            contentType: sanitizedContentType,
            date: sanitizedDate,
            metadata: {
                source: sanitizedSource,
                date: `${sanitizedDate.year}-${sanitizedDate.month}`,
                originalName: sanitizedOriginalName,
                type: sanitizedContentType,
                contentType: sanitizedContentType
            }
        };
    }

    sanitizeDate(date) {
        if (!date || typeof date !== "object") return null;
        const month = Number(date.month);
        const year = Number(date.year);
        const sanitizedDate = {};
        if (!Number.isNaN(month) && month >= 1 && month <= 12) {
            sanitizedDate.month = month;
        }
        if (!Number.isNaN(year)) {
            sanitizedDate.year = year;
        }
        if (!sanitizedDate.month || !sanitizedDate.year) return null;
        return sanitizedDate;
    }
}
